'use strict';

var cardSlideshow = require('./card-slideshow');
var accordionGallery = require('./accordion-gallery');

var init = function() {
	cardSlideshow.init();
	accordionGallery.init();

};

module.exports = {
	init: init
};
